var map = {
	"./1182/1182": 1150,
	"./1182/1182.mtl": 1150,
	"./1182/1182.obj": 2031,
	"./1182/TEMPLATES/1182.svg": 2032,
	"./1182/TEMPLATES/_colorbase_.jpg": 2033,
	"./1182/config": 1144,
	"./1182/config.json": 1144,
	"./18BR-20/18BR-20": 1151,
	"./18BR-20/18BR-20.mtl": 1151,
	"./18BR-20/18BR-20.obj": 2034,
	"./18BR-20/PrintPattern.png": 2035,
	"./18BR-20/TEMPLATES/18BR-20-01.svg": 2036,
	"./18BR-20/TEMPLATES/Style_1/Template_colorbase_1.png": 2037,
	"./18BR-20/TEMPLATES/Style_1/Template_logobase_1.png": 2038,
	"./18BR-20/TEMPLATES/Style_1/template-preview.png": 2039,
	"./18BR-20/TEMPLATES/Style_2/Template_colorbase_2.png": 2040,
	"./18BR-20/TEMPLATES/Style_2/Template_logobase_2.png": 2041,
	"./18BR-20/TEMPLATES/Style_2/template-preview.png": 2042,
	"./18BR-20/TEMPLATES/_seam_.png": 2043,
	"./18BR-20/TEMPLATES/no-image.png": 2044,
	"./18BR-20/config": 1145,
	"./18BR-20/config.json": 1145,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/BL002B": 1152,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/BL002B.mtl": 1152,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/BL002B.obj": 2045,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/TEMPLATES/BL002.svg": 2046,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/TEMPLATES/_colorbase_BL002.jpg": 2047,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/TEMPLATES/_seam_.png": 2048,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/TEMPLATES/default/_colorbase_BL002.png": 2049,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/TEMPLATES/default/_logobase_.png": 2050,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/TEMPLATES/default/template-preview.png": 2051,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/TEMPLATES/no-image.png": 2052,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/config": 1146,
	"./7dcfe26d-a531-4f3e-bee9-19b68bdb3ddf/config.json": 1146,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/BL002A": 1153,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/BL002A.mtl": 1153,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/BL002A.obj": 2053,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/TEMPLATES/BL002.svg": 2054,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/TEMPLATES/_colorbase_BL002.jpg": 2055,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/TEMPLATES/_seam_.png": 2056,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/TEMPLATES/default/_colorbase_BL002.png": 2057,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/TEMPLATES/default/_logobase_.png": 2058,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/TEMPLATES/default/template-preview.png": 2059,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/TEMPLATES/no-image.png": 2060,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/config": 1147,
	"./8de4b223-f193-476f-ba3e-e6b58b9ad4a9/config.json": 1147,
	"./AOP/Camouflage.png": 1373,
	"./AOP/UV_Grid_Sm.jpg": 1374,
	"./AOP/aop (1).jpg": 1375,
	"./AOP/aop (1).png": 1376,
	"./AOP/aop (2).jpg": 1377,
	"./AOP/aop (2).png": 1378,
	"./AOP/aop (3).jpg": 1379,
	"./AOP/aop (4).jpg": 1380,
	"./AOP/specialAOP (1).png": 2061,
	"./AOP/specialAOP (2).png": 2062,
	"./AOP/specialAOP (3).png": 2063,
	"./BG/bg (1).jpg": 1407,
	"./BG/bg (10).jpg": 1416,
	"./BG/bg (11).jpg": 1417,
	"./BG/bg (12).jpg": 1418,
	"./BG/bg (13).jpg": 1419,
	"./BG/bg (2).jpg": 1408,
	"./BG/bg (3).jpg": 1409,
	"./BG/bg (4).jpg": 1410,
	"./BG/bg (5).jpg": 1411,
	"./BG/bg (6).jpg": 1412,
	"./BG/bg (7).jpg": 1413,
	"./BG/bg (8).jpg": 1414,
	"./BG/bg (9).jpg": 1415,
	"./BG/brikl.png": 1420,
	"./NORMAL_MAP/001.jpg": 1383,
	"./NORMAL_MAP/002.jpg": 1384,
	"./NORMAL_MAP/003.jpg": 1385,
	"./NORMAL_MAP/004.jpg": 1386,
	"./NORMAL_MAP/005.jpg": 1387,
	"./NORMAL_MAP/006.jpg": 1388,
	"./NORMAL_MAP/007.jpg": 1389,
	"./NORMAL_MAP/008.jpg": 1390,
	"./NORMAL_MAP/009.jpg": 1391,
	"./NORMAL_MAP/010.jpg": 1392,
	"./NORMAL_MAP/011.jpg": 1393,
	"./NORMAL_MAP/012.jpg": 1394,
	"./NORMAL_MAP/013.jpg": 1395,
	"./NORMAL_MAP/014.jpg": 1396,
	"./NORMAL_MAP/015.jpg": 1397,
	"./NORMAL_MAP/016.jpg": 1398,
	"./NORMAL_MAP/017.jpg": 1399,
	"./NORMAL_MAP/018.jpg": 1400,
	"./NORMAL_MAP/019.jpg": 1401,
	"./NORMAL_MAP/020.jpg": 1402,
	"./NORMAL_MAP/021.jpg": 1403,
	"./NORMAL_MAP/Cotton_NORMAL_MAP.jpg": 1404,
	"./NORMAL_MAP/Thumb/001.jpg": 1117,
	"./NORMAL_MAP/Thumb/002.jpg": 1118,
	"./NORMAL_MAP/Thumb/003.jpg": 1119,
	"./NORMAL_MAP/Thumb/004.jpg": 1120,
	"./NORMAL_MAP/Thumb/005.jpg": 1121,
	"./NORMAL_MAP/Thumb/006.jpg": 1122,
	"./NORMAL_MAP/Thumb/007.jpg": 1123,
	"./NORMAL_MAP/Thumb/008.jpg": 1124,
	"./NORMAL_MAP/Thumb/009.jpg": 1125,
	"./NORMAL_MAP/Thumb/010.jpg": 1126,
	"./NORMAL_MAP/Thumb/011.jpg": 1127,
	"./NORMAL_MAP/Thumb/012.jpg": 1128,
	"./NORMAL_MAP/Thumb/013.jpg": 1129,
	"./NORMAL_MAP/Thumb/014.jpg": 1130,
	"./NORMAL_MAP/Thumb/015.jpg": 1131,
	"./NORMAL_MAP/Thumb/016.jpg": 1132,
	"./NORMAL_MAP/Thumb/017.jpg": 1133,
	"./NORMAL_MAP/Thumb/018.jpg": 1134,
	"./NORMAL_MAP/Thumb/019.jpg": 1135,
	"./NORMAL_MAP/Thumb/020.jpg": 1136,
	"./NORMAL_MAP/Thumb/021.jpg": 1137,
	"./NORMAL_MAP/polyester.jpg": 1138,
	"./SLT_P_MUJ/PrintPattern.jpg": 2064,
	"./SLT_P_MUJ/SLT_P_MUJ": 1154,
	"./SLT_P_MUJ/SLT_P_MUJ.mtl": 1154,
	"./SLT_P_MUJ/SLT_P_MUJ.obj": 2065,
	"./SLT_P_MUJ/TEMPLATES/SLT_P_MUJ_V7.svg": 2066,
	"./SLT_P_MUJ/TEMPLATES/no-image.png": 2067,
	"./SLT_P_MUJ/TEMPLATES/style_1/_colorbase_.png": 2068,
	"./SLT_P_MUJ/TEMPLATES/style_1/_logobase_.png": 2069,
	"./SLT_P_MUJ/config": 1148,
	"./SLT_P_MUJ/config.json": 1148,
	"./YOGA/STACKS/Print pattern XL-01.svg": 1424,
	"./YOGA/STACKS/Print pattern size L seam allowance.svg": 1425,
	"./YOGA/TEMPLATES/02/Print pattern XS-02_colorbase_3000-01.png": 1426,
	"./YOGA/TEMPLATES/02/Print pattern XS-02_logobase_3000-01.png": 1427,
	"./YOGA/TEMPLATES/02/template-preview.png": 1428,
	"./YOGA/TEMPLATES/03/Print pattern XS-03_colorbase_3000-01.png": 1429,
	"./YOGA/TEMPLATES/03/Print pattern XS-03_logobase_3000-01.png": 1430,
	"./YOGA/TEMPLATES/03/template-preview.png": 1431,
	"./YOGA/TEMPLATES/Print pattern XS-01.svg": 1432,
	"./YOGA/TEMPLATES/Print pattern XS-01_seam_-01.png": 1433,
	"./YOGA/TEMPLATES/no-image.png": 1434,
	"./YOGA/XS": 967,
	"./YOGA/XS.mtl": 967,
	"./YOGA/XS.obj": 1435,
	"./YOGA/config": 1000,
	"./YOGA/config.json": 1000,
	"./bicycle.gif": 1442,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/BL001": 1155,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/BL001.mtl": 1155,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/BL001.obj": 2070,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/TEMPLATES/BL001.svg": 2071,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/TEMPLATES/_colorbase_BL001.jpg": 2072,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/TEMPLATES/_seam_.png": 2073,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/TEMPLATES/default/_colorbase_BL001.png": 2074,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/TEMPLATES/default/_logobase_.png": 2075,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/TEMPLATES/default/template-preview.png": 2076,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/TEMPLATES/no-image.png": 2077,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/config": 1149,
	"./da9af25f-b840-4971-b9f2-0cb4eef379bc/config.json": 1149,
	"./flags": 1043,
	"./flags.json": 1043,
	"./loading1.gif": 1437,
	"./loading2.gif": 1438,
	"./loading3.gif": 1439,
	"./loading4.gif": 1440,
	"./logo/Vermarc_Logo_White.png": 2078,
	"./logo/logo_icon.png": 2079,
	"./logo/unnamed.jpg": 2080,
	"./no-image.png": 999,
	"./productListBodywearlab": 1444,
	"./productListBodywearlab.json": 1444,
	"./productListLocal": 1445,
	"./productListLocal.json": 1445,
	"./productListVermarc": 1446,
	"./productListVermarc.json": 1446,
	"./productListXceed": 1447,
	"./productListXceed.json": 1447,
	"./productListYuepai": 1448,
	"./productListYuepai.json": 1448,
	"./tab_loading.gif": 1441,
	"./transparent.png": 1143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 917;